var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckInFacilities = function SvgCheckInFacilities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 19.2 19.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M18.6 18.6H.6m9-10.34c1.684 0 3.196.845 4.237 2.189M9.597 2.24H8.175C8.174 1.335 8.815.6 9.6.6s1.421.735 1.421 1.641zm0 0V4.43m0 0h.098c4.918 0 8.905 4.605 8.905 10.286v.304H.6v-.304C.6 9.036 4.587 4.43 9.505 4.43z"
  })));
};
export default SvgCheckInFacilities;